/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedDmvsGadDocUpdateRequest } from '../types/PatchedDmvsGadDocUpdate';
import type { DmvsGadDocUpdateResponse } from '../types/DmvsGadDocUpdate';

export type DmvsGadDocsPartialUpdateRequest = PatchedDmvsGadDocUpdateRequest;
export type DmvsGadDocsPartialUpdateResponse = DmvsGadDocUpdateResponse;

export type DmvsGadDocsPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/dmvs_gad_docs/{id}/
 *
 * ```yaml
 * operationId: dmvs_gad_docs_partial_update
 * tags:
 *   - dmvs_gad_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDmvsGadDocUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDmvsGadDocUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDmvsGadDocUpdate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DmvsGadDocUpdate'
 *     description: ''
 * ```
 */
export const dmvsGadDocsPartialUpdateOperation = ({ id, ...rest }: DmvsGadDocsPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/dmvs_gad_docs/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/dmvs_gad_docs/{id}/' };
  };

/**
 * PATCH /dmx-server/dmvs_gad_docs/{id}/
 *
 * ```yaml
 * operationId: dmvs_gad_docs_partial_update
 * tags:
 *   - dmvs_gad_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDmvsGadDocUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDmvsGadDocUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedDmvsGadDocUpdate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DmvsGadDocUpdate'
 *     description: ''
 * ```
 */
export const dmvsGadDocsPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DmvsGadDocsPartialUpdateQuery;
  request: PatchedDmvsGadDocUpdateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DmvsGadDocUpdateResponse>> => {
  const operation = dmvsGadDocsPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
